import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { PermissionsList } from '@config/components';

export const PermissionsPage = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Title>{t('config.sections.permissions')}</Page.Title>
      <Page.Content fill>
        <PermissionsList />
      </Page.Content>
    </Page>
  );
};
